import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LANG_SIGNAL, LsSectionBandComponent } from '@lyricstream/shared';
import { TranslateModule } from '@ngx-translate/core';
import { LyricListSectionComponent } from '../lyric-list-section/lyric-list-section.component';

/**
 * Rubrique « chants » : bande + en-tête + liste réelle (`ls-lyric-list-section`).
 * `popular` = classement par consultations, `latest` = derniers ajouts au catalogue.
 */
@Component({
  selector: 'app-lyric-list-band',
  imports: [TranslateModule, LsSectionBandComponent, LyricListSectionComponent],
  templateUrl: './lyric-list-band.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block; }'],
  host: { '[attr.data-testid]': '"section-" + mode()' },
})
export class LyricListBandComponent {
  private readonly lang = inject(LANG_SIGNAL);

  readonly mode = input.required<'popular' | 'latest'>();
  readonly tinted = input<boolean>(false);

  /** Clés de traduction (eyebrow, titre) et page « Tout voir » selon le mode. */
  protected readonly texts = computed(() =>
    this.mode() === 'popular'
      ? { eyebrow: 'HOME.POPULAR.EYEBROW', heading: 'HOME.POPULAR.H2', link: ['/', this.lang(), 'popular'] }
      : { eyebrow: 'HOME.LATEST.EYEBROW', heading: 'HOME.LATEST.H2', link: ['/', this.lang(), 'recents'] },
  );
}
